import { setToken } from '../lib/api';

export async function renderAuthCallback(container: HTMLElement): Promise<void> {
  console.log('Auth callback page loaded');
  console.log('Full URL:', window.location.href);

  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');

  console.log('Token from URL:', token);

  if (token) {
    console.log('Storing token in localStorage');
    setToken(token);
    console.log('Token stored, redirecting to dashboard');
    window.location.href = '/dashboard';
  } else {
    console.log('No token found, redirecting to login with error');
    window.location.href = '/?error=auth_failed';
  }

  container.innerHTML = '<div class="container"><p>Logging in...</p></div>';
}
